// components/configuration/tabs/NotificationRulesTab.jsx
import React from 'react';
import NotificationRulesManager from '../../../components/configuration/sections/NotificationRulesManager';

/**
 * Admin-only notification rules management tab
 */
const NotificationRulesTab = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Notification Rules Management
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Control which notification rules are active and who can see them. 
          Users can then customize their own preferences for enabled rules.
        </p>
        
        <NotificationRulesManager />
      </div>
    </div>
  );
};

export default NotificationRulesTab;
